// tools.js
import Embed from "@editorjs/embed";
import Table from "@editorjs/table";
import List from "@editorjs/list";
import Paragraph from "@editorjs/paragraph";
import Warning from "@editorjs/warning";
import Code from "@editorjs/code";
import LinkTool from "@editorjs/link";
import Raw from "@editorjs/raw";
import Header from "@editorjs/header";
import Quote from "@editorjs/quote";
import Marker from "@editorjs/marker";
import CheckList from "@editorjs/checklist";
import Delimiter from "@editorjs/delimiter";
import InlineCode from "@editorjs/inline-code";
import SimpleImage from "@editorjs/simple-image";
import Image from "@editorjs/image";
import ColorPlugin from "editorjs-text-color-plugin";
import AlignmentBlockTuneWithJustify from "./alignment-tune";
import CTATool from "./cta-tool";
import api from "../../../../utils/axios";

export const EDITOR_JS_TOOLS = {
  // NOTE: Paragraph is default tool. Declare only when you want to change paragraph option.
  paragraph: {
    class: Paragraph,
    inlineToolbar: true,
    tunes: ["alignment"],
    config: {
      placeholder: "Start writing your blog content here...",
    },
  },
  //   embed: Embed,
  table: {
    class: Table,
    inlineToolbar: true,
    config: {
      rows: 2,
      cols: 3,
    },
  },
  list: {
    class: List,
    inlineToolbar: true,
    tunes: ["alignment"],
    config: {
      defaultStyle: "unordered",
    },
  },
  //   warning: {
  //     class: Warning,
  //     inlineToolbar: true,
  //     config: {
  //       titlePlaceholder: "Title",
  //       messagePlaceholder: "Message",
  //     },
  //   },
  //   code: {
  //     class: Code,
  //     config: {
  //       placeholder: "Enter code here...",
  //     },
  //   },
  linkTool: {
    class: LinkTool,
    // config: {
    //   endpoint: "/api/link-preview", // Your backend endpoint for link preview
    //   // If endpoint fails, links will still work with just the URL
    // },
  },
  image: {
    class: Image,
    config: {
      endpoints: {
        byFile: "/user/upload/multipart", // Use the same upload API as blog cover images
        byUrl: "/api/fetch-image", // Your backend endpoint for image fetch
      },
      field: "file", // The field name for the file upload
      additionalRequestData: {
        uploadPath: "/uploads/blogs", // Upload path for blog images
      },
      captionPlaceholder: "Image caption",
      buttonContent: "Select an image",
      uploader: {
        uploadByFile(file) {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("uploadPath", "uploads/blogs");

          return api
            .post("/user/upload/multipart?public=true", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => response.data)
            .then((result) => {
              if (result.success) {
                // Store only the path (s3Key) for saving
                return {
                  success: 1,
                  file: {
                    url: result.data.uploadUrl, // Store just the path, not full URL
                  },
                };
              } else {
                throw new Error(result.message || "Upload failed");
              }
            });
        },
        uploadByUrl(url) {
          return api
            .post("/api/fetch-image", {
              url,
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ url }),
            })
            .then((response) => response.json())
            .then((result) => {
              if (result.success) {
                return {
                  success: 1,
                  file: {
                    url: result.url,
                  },
                };
              } else {
                throw new Error(result.message || "Fetch failed");
              }
            });
        },
      },
    },
  },
  raw: {
    class: Raw,
    config: {
      placeholder: "Enter HTML code here...",
    },
  },
  header: {
    class: Header,
    inlineToolbar: true,
    tunes: ["alignment"],
    config: {
      placeholder: "Enter a header",
      levels: [1, 2, 3, 4, 5, 6],
      defaultLevel: 2,
    },
  },
  quote: {
    class: Quote,
    inlineToolbar: true,
    tunes: ["alignment"],
    config: {
      quotePlaceholder: "Enter a quote",
      captionPlaceholder: "Quote's author",
    },
  },
  marker: {
    class: Marker,
    shortcut: "CMD+SHIFT+M",
  },
  checklist: {
    class: CheckList,
    inlineToolbar: true,
  },
  Color: {
    class: ColorPlugin,
    config: {
      colorCollections: [
        "#EC7878",
        "#9C27B0",
        "#673AB7",
        "#3F51B5",
        "#0070FF",
        "#00BCD4",
        "#4CAF50",
        "#8BC34A",
        "#FFC107",
        "#FF9800",
        "#FF5722",
        "#795548",
        "#9E9E9E",
        "#607D8B",
        "#000000",
        "#FFFFFF",
      ],
      defaultColor: "#FF1300",
      type: "text",
      customPicker: true, // allow selecting any color
    },
  },
  alignment: {
    class: AlignmentBlockTuneWithJustify,
    config: {
      default: "left",
      blocks: {
        header: "center",
        list: "left",
      },
    },
  },
  cta: {
    class: CTATool,
    inlineToolbar: false,
  },
  //   delimiter: Delimiter,
  //   inlineCode: {
  //     class: InlineCode,
  //     shortcut: "CMD+SHIFT+M",
  //   },
  //   simpleImage: {
  //     class: SimpleImage,
  //     config: {
  //       placeholder: "Paste image URL or upload file",
  //       uploader: {
  //         uploadByFile(file) {
  //           const formData = new FormData();
  //           formData.append("file", file);
  //           formData.append("uploadPath", "/uploads/blogs");

  //           return api
  //             .post("/user/upload/multipart", formData, {
  //               headers: {
  //                 "Content-Type": "multipart/form-data",
  //               },
  //             })
  //             .then((response) => response.data)
  //             .then((result) => {
  //               if (result.success) {
  //                 return {
  //                   success: 1,
  //                   file: {
  //                     url: `${result.data.s3Key}`,
  //                   },
  //                 };
  //               } else {
  //                 throw new Error(result.message || "Upload failed");
  //               }
  //             });
  //         },
  //       },
  //     },
  //   },
};
